import { render, staticRenderFns } from "./TopNavbar.vue?vue&type=template&id=a05fbe0e&scoped=true"
import script from "./TopNavbar.vue?vue&type=script&lang=ts"
export * from "./TopNavbar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a05fbe0e",
  null
  
)

export default component.exports